import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import aboutStyles from "../styles/About.module.css";

const About = () => {
  const [showPopup, setShowPopup] = useState(false);

  return (
    <Container className="my-5">
      <Row className="justify-content-center mb-4">
        <Col md={10} lg={10}>
          <h1>About Lisa</h1>
          <p>
            Initially qualifying with a Diploma in Humanistic Counselling,
            followed by a Level 3 Certificate in CBT (Cognitive Behavioural
            Therapy). I have since worked with an enormous variety of people and
            numerous complex issues.
            <br />
            <br />
            With over twenty years of experience in my private practice,
            alongside referrals from local schools, CAMHS (Child and Adolescent
            Mental Health Services), GP surgeries and{" "}
            <a
              href="https://www.hrconnect.org.uk/staff-care-services"
              target="_blank"
              rel="noreferrer"
            >
              Staff Care Services (via their workplace EAP schemes)
            </a>
            , I bring a wide breadth of professional experience to each session,
            believing that the most important part of counselling is the
            relationship between the counsellor and their client and the safe
            space that is created based on this.
            <br /> <br />
            <hr />
            <br />I am an Accredited and registered member of the{" "}
            <a
              href="https://www.bacp.co.uk/search/Register?UserLocation=51.249152%2C1.032192&q=Lisa+David&SortOrder=2"
              target="_blank"
              rel="noreferrer"
            >
              BACP
            </a>{" "}
            (British Association for Counselling and Psychotherapy). And as
            such, abide by their Ethical Framework and Good Practice. Strictly
            adhering to BACP’s requirements for Professional Development, adding
            string after string to my bow in order to support every client I
            work with. Examples of such strings is use of Clinical
            <a
              href="https://pubmed.ncbi.nlm.nih.gov/36438382/"
              target="_blank"
              rel="noreferrer"
            >
              EFT (Emotional Freedom Technique)
            </a>
            , in which I am an Advanced Practitioner as well as a qualified
            practitioner of Matrix Reimprinting and
            <a
              href="https://pmc.ncbi.nlm.nih.gov/articles/PMC3951033/"
              target="_blank"
              rel="noreferrer"
            >
              {" "}
              EMDR (Eye Movement Desensitisation and Reprocessing
            </a>
            ), both of which work at a deeper level, reaching depths that
            ordinary talking therapies often fail to reach.
          </p>
          <br />

          <hr classname={aboutStyles.Line} />
          <br />

          <h2>Training, qualifications & experience</h2>

          <p>
            <span
              className={`${aboutStyles.popupWrapper} ${aboutStyles.popupTriggerText}`}
              onMouseEnter={() => setShowPopup(true)}
              onMouseLeave={() => setShowPopup(false)}
              onTouchStart={() => setShowPopup(true)}
              onTouchEnd={() => setShowPopup(false)}
            >
              • BACP Accredited & Registered Therapist
              {showPopup && (
                <div className={aboutStyles.popupContainer}>
                  <img
                    src="/bacp-accreditation-badge.jpg"
                    alt="BACP Accreditation Badge"
                    style={{ width: "200px", height: "auto" }}
                  />
                </div>
              )}
            </span>
            <br />• Diploma in Humanistic Counselling
            <br />• CBT Level 3
            <br />• EMDR Therapist
            <br />• Advanced Practitioner EFT
            <br />• Matrix Reimprinting
            <br />• Child Protection Training
            <br />• Current Enhanced DBS Certificate.
          </p>
        </Col>
      </Row>
    </Container>
  );
};

export default About;
